export var NonBuyableResources = [
    "loyaltyPoints",
    "pawPrints",
    "chestKeys",
    "coupons",
    "adventureCoins",
];



//////////////////
// WEBPACK FOOTER
// ./src/constants/NonBuyableResources.ts
// module id = 2851
// module chunks = 3